import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import axios from 'axios';
import { Select, Dropdown, Menu, notification } from 'antd';
import { Icon } from 'dlweb-components';
import _ from 'lodash';

const TaskFiles = ({hideModal, task, onFileSelected, user, readOnly}) => {

  const containerRef = useRef(null);

  const [files, setFiles] = useState([]);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [menuDisabled, setMenuDisabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const angularScopeHook = window.angular.element('#container');
  const angularScope = angularScopeHook.scope();

  useEffect(() => {
    if(!_.isEmpty(task)) {
      setLoading(true);
      axios.post('/api/wt/workflow/dto/file/read', { ...task }).then(
        res => {
          setFiles(res.data.data);
          setLoading(false);
        }
      ).catch(error => {
        alert(`Error loading files.`)
        setLoading(false);
        console.error(error);
      });
    } 
  }, [task])

  useEffect(() => {

    if(files.length > 0) {

      const defaultSelectedId = files[0].fileId;

      setSelectedFileId(defaultSelectedId);
      onFileSelected(defaultSelectedId);
      setMenuDisabled(false);
    }
    else {
      setMenuDisabled(true);
    }
  }, [files, onFileSelected, setMenuDisabled])

  const iconStyle = {
    width: '25px',
    marginRight: '10px'
  }

  const onMenuItemClicked = (menuKey) => {
    setLoading(true);
    const fileIdArray = [{ID: selectedFileId}];
    const fileObject = _.find(files, { fileId: selectedFileId });

    const fileService = angularScopeHook.injector().get('File');
    const utilityService = angularScopeHook.injector().get('Utility');
    const locationService = angularScopeHook.injector().get('$location');

    switch (menuKey) {
      case 'navigate':
          const url = utilityService.getLinkURL(selectedFileId);
          locationService.url(url);
          angularScope.$apply();
          hideModal();
        break;
      case 'download':
        fileService.download(fileIdArray, 'download');
        setLoading(false);
        break;
      case 'checkout':
          const checkoutCallback = () => {
            setFiles(f => {
              _.find(f, { fileId: selectedFileId }).checkedOutBy = `<${user}>`;
              return f;
            });
            setLoading(false);
          }

          fileService.download(fileIdArray, 'checkout', checkoutCallback);
        break;
        case 'undoCheckout':
          const undoCallback = () => {
            setFiles(f => {
              _.find(f, { fileId: selectedFileId }).checkedOutBy = '';
              return f;
            });
            setLoading(false);
          }
          
          fileService.undoCheckout(fileIdArray, false, undoCallback);
        break;
      case 'checkin':
        angularScope.closeDialog = () => {
          setLoading(true);
          setFiles(f => {
            _.find(f, { fileId: selectedFileId }).checkedOutBy = '';
            setLoading(false);
            return f;
          })
          onFileSelected(selectedFileId);
        }

         const checkinFile = [
          {
            ID: selectedFileId,
            Status: 'checked out',
            CheckedOutBy: fileObject.checkedOutBy.replace('<', '').replace('>', '')
          }
        ];

        window.launchLegacyDialog('checkin', checkinFile, null, null, null, user);
        setLoading(false);
        break;
      case 'updateProfile':
        angularScope.closeDialog = () => {}
        window.launchLegacyDialog('updateprofile', fileIdArray);
        setLoading(false);
        break;
      case 'redLines':
        setLoading(false);
        break;
      default:
        break;
    }
  }

  const onSelect = (fileId) => {
    onFileSelected(fileId);
    setSelectedFileId(fileId);
  }

  const menu = () => {

    const fileObject = _.find(files, { fileId: selectedFileId });

    return (
    <Menu onClick={menuItem => onMenuItemClicked(menuItem.key)}>
      <Menu.Item key='navigate'>
        <Icon type="compass" style={iconStyle}/>
        Navigate
      </Menu.Item>
      <Menu.Item key='download'>
        <Icon type="file-download" style={iconStyle}/>
        Download
      </Menu.Item>
      {fileObject.checkedOutBy && !readOnly &&
        <Menu.Item key='undoCheckout' disabled={fileObject.checkedOutBy !== `<${user}>`}>
          <Icon type="undo" style={iconStyle}/>
          Undo Check Out
        </Menu.Item>
      }
      {fileObject.checkedOutBy && !readOnly &&
        <Menu.Item key='checkin' disabled={fileObject.checkedOutBy !== `<${user}>`}>
        <Icon type="file-upload" style={iconStyle}/>
          Check In
        </Menu.Item>
      }
      {!fileObject.checkedOutBy && !readOnly &&
        <Menu.Item key='checkout'>
          <Icon type="check" style={iconStyle}/>
          Check Out
        </Menu.Item>
      }
      {!readOnly &&
        <Menu.Item key='updateProfile'>
          <Icon type="pen-square" style={iconStyle}/>
          Update Profile
        </Menu.Item>
      }
      {/* <Menu.Item key='redLines'>
        <Icon type="not-equal" style={iconStyle}/>
        Red Lines
      </Menu.Item> */}
    </Menu>
  )};

  return (
    <MainContainer ref={containerRef}>
      <TextContainer>
        Document:
      </TextContainer>
      <SelectContainer parentContainer={containerRef}>
        <Select style={{width: "100%"}} value={selectedFileId} onSelect={onSelect} loading={loading} disabled={loading || menuDisabled}>
          {files.map(file => (  
            <Select.Option key={file.fileId} value={file.fileId}>
              {file.checkedOutBy &&
                <Icon type="check" style={{paddingRight: '10px', color: '#CC3333'}}/>
              }
              {file.fileName}
            </Select.Option>
          ))}
        </Select>
        <Dropdown 
          overlay={menu}
          trigger={['click']}
          placement="bottomRight"
          disabled={menuDisabled}
        >
          <IconContainer disabled={menuDisabled}>
            <Icon type="ellipsis-h"/>
          </IconContainer>
        </Dropdown>
      </SelectContainer>
    </MainContainer>
  )
}

const MainContainer = styled.div`
 display: flex;
 padding-bottom: 15px;
 background-color: #fff;
`

const TextContainer = styled.div`
  flex: 0 0 68px;
  margin-right: 10px;
  line-height: 32px;
`

const SelectContainer = styled.div`
  flex: 1;
  text-align: initial;
  padding-right: 40px;
`

const IconContainer = styled.div`
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 11px;
  line-height: 30px;
  font-size: 20px;
  border: 1px solid #ccc;
  background-color: ${p => p.disabled ? '#f5f5f5' : '#fff' };
`

export default TaskFiles;
